import { PreviewError } from "../responses/previewTransformationReponse";
import { MoovStepInstance } from "./moovStepInstance";

export class FileItem{
    public fileContent!:string;
    public fileContentDirty:boolean=false;
    
    constructor(public blob:Blob, public fileDisplayName:string, public filePath:string|undefined, public outputFileType:string|undefined, public canEdit:boolean, 
        public moovFileId:number|undefined, public moovStepInstance:MoovStepInstance|undefined, public message:string|undefined, public errors:PreviewError[]|undefined, public added:Date|undefined){
    }

    get canRestore(){
        return this.canEdit && this.moovStepInstance?.inputFile.filepath!=this.moovStepInstance?.outputFile.filepath;
    }

    get canSave(){
      return this.canEdit && this.fileContentDirty;
  }

    get xmlFileContent(){
        return this.formatXml(this.fileContent,undefined);
    }

    private formatXml(xml:string, tab:string|undefined) { // tab = optional indent value, default is tab (\t)
        var formatted = '', indent= '';
        tab = tab || '\t';
        xml.split(/>\s*</).forEach(function(node) {
            if (node.match( /^\/\w/ )) indent = indent.substring(tab.length); // decrease indent by one 'tab'
            formatted += indent + '<' + node + '>\r\n';
            if (node.match( /^<?\w[^>]*[^\/]$/ )) indent += tab;              // increase indent
        });
        return formatted.substring(1, formatted.length-3);
    }

    get fileNameWithExtension(){
        switch(this.outputFileType){
          case 'csv':
          case 'mrt-csv':
          case 'grt-csv':
            return this.fileDisplayName + '.csv';
          case 'fl':
          case 'mrt-fl':
          case 'grt-fl':
            return this.fileDisplayName + '.txt';
          case 'xml':
            return this.fileDisplayName + '.xml';
          case 'json':
            return this.fileDisplayName + '.json';
          default:
            return this.fileDisplayName;
        }
    }

    get jsonFileContent(){
        return this.formatJson(this.fileContent);
    }

    private formatJson(json:string){
        //parse into json object first, then use json pipe in html
        return JSON.parse(json);
    }

    public contentUpdated(){
      this.fileContentDirty=true;
    }

    public async updateFileContent(): Promise<void> {
      if (this.blob) this.fileContent = await this.blob.text();
      else this.fileContent = 'no content';
      this.fileContentDirty = false;
    }
}